import { API_BASE_URL } from '@synergy/config';
import { padZeroLeft } from '@synergy/utils';

import { BaseAutocompleteSuggestionType } from '../../../../../common/components/autocomplete-list/pool-autocomplete-list';
import {
    BonusSettlementSearchSupplier,
    BonusSettlementSupplier,
} from '../../models/bonus-settlement-supplier-overview';
import { BonusSettlementsSupplierOverviewApi } from '../../api/bonus-settlements-supplier-overview-api';
import { PoolFormAutocompleteList } from '../../../../../common/components/abstract/form-autocomplete-list';

export interface PartialBonusSettlementSupplier extends BaseAutocompleteSuggestionType {
    name?: string;
    city?: string;
}

interface PoolBonusSettlementSupplierAutocompleteListProps {
    bonusSettlementId: number;
}

class PoolBonusSettlementSupplierAutocompleteListBase extends PoolFormAutocompleteList<
    BonusSettlementSearchSupplier,
    PartialBonusSettlementSupplier,
    PoolBonusSettlementSupplierAutocompleteListProps
> {
    private api = new BonusSettlementsSupplierOverviewApi(API_BASE_URL);

    public componentDidMount() {
        this.setState({ items: [] });
    }

    public getSuggestionValue = (suggestion: PartialBonusSettlementSupplier) =>
        suggestion && suggestion.name ? suggestion.name : '';

    public async handleValueChanged(search: string) {
        const searchParams = new URLSearchParams({ search, limit: '40' });
        const response = await this.api.getBonusSettlementSearchSuppliers(this.props.bonusSettlementId, searchParams);
        const items = response.success === true ? response.result.items : [];
        this.setState({ items });
    }

    public getPartial = (suppliers: BonusSettlementSearchSupplier[]): PartialBonusSettlementSupplier[] =>
        suppliers.map(supplier => {
            return {
                id: padZeroLeft(supplier.id, 5),
                name: supplier.name ?? '',
                city: supplier.city ?? '',
            };
        });

    public getDisplayValue(supplier: BonusSettlementSupplier) {
        return supplier.city ? `${supplier.supplierName}, ${supplier.city}` : supplier.supplierName;
    }
}

export const PoolBonusSettlementSupplierAutocompleteList = PoolBonusSettlementSupplierAutocompleteListBase;
